// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2aSIU","list":"PatternAutocomplete_list__2ir8H"};